import React, { Suspense } from "react";
import Routes from "../../routes";  // fixed import path

const LoadingFallback = () => (
  <div className="d-flex align-items-center vh-100 justify-content-center text-center font-weight-bold font-size-lg py-3">
    <div className="w-50 mx-auto">Please wait while we load CT-Onlinq for you....</div>
  </div>
);

const Main = () => (
    <Suspense fallback={<LoadingFallback />}>
      <Routes />
    </Suspense>
);

export default Main;
